import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import BarraContainer from '../general/BarraContainer';
import TableContainer from '../general/TableContainer';
import UploadMachines from './UploadMachines';
import InsertTask from './InsertTask';
import OrderManagement from './OrderManagement';
import Modal from '../general/Modal';
import './MachineDetails.css'; // Asegúrate de crear y ajustar este archivo CSS según tus necesidades
import { API_URL } from '../../config';
import { selectSubMenu, setData} from '../../actions';
import { getTasksByMachine, deleteTasksByIds, updateMachine, deleteMachines, getHistoriesByEmpresa } from '../general/api'; // Importa las funciones de API
import InsertCorrectivo from './InsertCorrectivo';
import HistoryDetail from './HistoryDetail';

const MachineDetails = ({ user, machine, buttonList, navigationHistory }) => {
  
  const dispatch = useDispatch();
  const imageUrl = `${API_URL}${machine.Path_Photo_Machine}`;
  const [isEditing, setIsEditing] = useState(false);
  const [editValues, setEditValues] = useState({ ...machine });
  const [activeSection, setActiveSection] = useState('Detalles de la Máquina');
  const [activeButton, setActiveButton] = useState('');
  const [data1, setDatos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const orders = useSelector((state) => state.machine.orders);
  const taskType = useSelector((state) => state.machine.taskType);
  const Actualizar = useSelector((state) => state.menu.data);
  const loading = useSelector((state) => state.machine.loading);
  const [selectedFilas, setSelectedFilas] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);


  const columns1 = [
    { header: '# Tarea', field: 'Id_Task', visible: false },
    { header: 'Codigo de Tarea', field: 'Internal_Code'},
    { header: 'Codigo de Maquína', field: 'Internall_Code_Machine', visible: false},
    { header: 'Descripción', field: 'Description' },
    { header: 'Periodo (días)', field: 'Interval' },
    { header: 'Insumos usados', field: 'Supplies' },
    { header: 'Tipo de Tarea', field: 'Name_Task_Type'}
    // Agrega más columnas según tus necesidades 
  ];
  
  const tableColumnsOrders = [
    { header: '# Orden', field: 'Id_Order', visible: false },
    { header: 'Código de Tarea', field: 'Internal_Code' },
    { header: 'Codigo de Maquína', field: 'Internall_Code_Machine', visible: false},
    { header: 'Tipo de Tarea', field: 'Name_Task_Type' },
    { header: 'Fecha Programada', field: 'Scheduled_Date' },
    { header: 'Estado', field: 'Status' },
    { header: 'Usuario Asignado', field: 'Name_User' },
    { header: 'Descripción de la Tarea', field: 'Description', visible: false },
    { header: 'Insumos usados', field: 'Supplies', visible: false },
  ];

  const tableColumnsHistory = [
    { header: 'Historial', field: 'Id_History', visible: false },
    { header: 'Orden', field: 'Id_Order'},
    { header: 'Código de Tarea', field: 'Id_Task', visible: false},
    { header: 'Descripción de la Tarea', field: 'Description_Task' },
    { header: 'Código de Máquina', field: 'Id_Machine', visible: false},
    { header: 'Nombre de Máquina', field: 'Name_Machine', visible: false },
    { header: 'Empresa', field: 'Name_Emp', visible: false },
    { header: 'Usuario Asignado', field: 'Name_User' },
    { header: 'Fecha Programada', field: 'Scheduled_Date' },
    { header: 'Estado', field: 'Status' },
    { header: 'Prioridad', field: 'Priority', visible: false},
    { header: 'Observaciones', field: 'Observation'},
    { header: 'Marca de Tiempo', field: 'Timestamp'}
  ];
  const fetchHistory = async () => {
      try {
          setHistorial(await getHistoriesByEmpresa(machine.Id_Empresa));
          filtarHistorial();
      } catch {
          console.log('Error al obtener historial');
      } 
  };

  const filtarHistorial = () => {
      const historialFiltrado = historial.reduce((acc, curr) => {
          if (curr.Id_Machine === machine.Id_Machine) {
              if (!acc[curr.Id_Order] || new Date(curr.Timestamp) > new Date(acc[curr.Id_Order].Timestamp)) {
                  acc[curr.Id_Order] = curr;
              }
          }
          return acc;
      }, {});
      setFilteredHistory(Object.values(historialFiltrado));
  };
  
  
  useEffect(() => {
    fetchHistory();
  }, [orders]);

  // Fetch tasks data when the component mounts or machine changes
  useEffect(() => {
    dispatch(setData('Maquinas'));
    const fetchData = async () => {
      try {
        const data = await getTasksByMachine(machine.Id_Machine);
        data[0].Internall_Code_Machine = machine.Internall_Code_Machine;
        setDatos(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
    dispatch(setData('Ordenes'));
  }, [machine, showModal, user.Id_Empresa, Actualizar]);

  // Filter orders based on task data
  useEffect(() => {
    if (orders && Array.isArray(data1)) {
      setFilteredOrders(orders.filter(order => data1.some(data => data.Id_Task === order.Id_Task)));
    }
  }, [orders, data1, showModal]);

  if (buttonList.includes('import')) {
    buttonList.push('edit');
  }

  // Function to delete tasks
  const deleteTasks = async (tasks) => {
    let confirmDelete = false;
    if (Array.isArray(tasks) && tasks.length > 1) {
      confirmDelete = window.confirm(`¿Está seguro de que desea borrar las siguientes Tareas: ${tasks.map(task => task.Internal_Code).join(', ')}?`);
    } else if (Array.isArray(tasks) && tasks.length === 1 && tasks[0] !== null) {
        confirmDelete = window.confirm(`¿Está seguro de que desea borrar la Tarea: ${tasks[0].Internal_Code}?`);
    } else {
        confirmDelete = false;
    }
  

    if (confirmDelete) {
      try {
        dispatch(setData('Maquinas'));
        const results = await deleteTasksByIds(tasks);
        const errors = results.filter(result => result.error);
        if (errors.length === 0) {
          alert(JSON.stringify(results));
        } else {
          alert(JSON.stringify(errors));
        }
        dispatch(setData('Ordenes'));
      } catch (error) {
        console.error(error);
        alert('Error al borrar las tareas');
      }
      //dispatch(selectSubMenu('ordenes'));
    } else {
      alert('No has elegido tareas para eliminar');
    }
  };

  const deleteMachine = async (userId, selectedMachines) => {
    dispatch(setData('Maquinas'));
      try {
          const result = await deleteMachines(userId, selectedMachines);
          dispatch(selectSubMenu('maquinas'));
          if (result.Success) {
              alert(JSON.stringify(result.Success));
          }
      } catch (error) {
          console.error(error);
          alert('No se borraron máquinas o no se seleccionó máquina alguna');
      }
      dispatch(setData('Ordenes'));
  };

  const handleSectionClick = (section) => {
    setSelectedFilas(null);
    setActiveSection(section);
  };

  const handleButtonClick = (button) => {
    dispatch(setData('Maquinas'));
    setActiveButton(button);
    setShowModal(false);
    if (button === 'add') {
      if (activeSection === 'Detalles de la Máquina') {
        dispatch(selectSubMenu('insertMachine'));
      } else if (activeSection === 'Tareas de Mantenimiento') {
        setShowModal(true);
      } else if (activeSection === 'Ordenes de Mantenimiento') {
        setShowModal(true);
        setActiveButton('add');
      }      
    } else if (button === 'edit') {
      if (activeSection === 'Detalles de la Máquina') {
        setIsEditing(!isEditing);
      } else if (activeSection === 'Tareas de Mantenimiento') {
        if (selectedFilas){
          setShowModal(true);
          }else{
            alert('No has seleccionado tareas para editar');
          }
      } else if (activeSection === 'Ordenes de Mantenimiento') {
        if (selectedFilas){
          setShowModal(true);
          }else{
            alert('No has seleccionado Ordenes de Mantenimiento para editar');
          }
      }
    } else if (button === 'delete') {
      if (activeSection === 'Detalles de la Máquina') {
        deleteMachine(user, [machine]);
      } else if (activeSection === 'Tareas de Mantenimiento') {
        deleteTasks(selectedFilas);
      } else if (activeSection === 'Ordenes de Mantenimiento') {
        setShowModal(true);
      }      
    } else if (button === 'import') {
      setShowModal(true);
    } else if (button === 'export') {
      if (activeSection === 'Detalles de la Máquina') {
        openFile(`${API_URL}${machine.Path_Manual_Machine}`);
      }else{
        setShowModal(true);
      }
    }
    dispatch(setData('Ordenes'));
  };

  const openFile = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank'; // Abrir en una nueva pestaña
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleInputChange = (field, value) => {
    setEditValues({
      ...editValues,
      [field]: value,
    });
  };

  const handleSave = async () => {
    try {
      dispatch(selectSubMenu('maquinas'));
      const response = await updateMachine(user, editValues);
      if (response) {
        alert(JSON.stringify(response));
      }
    } catch (error) {
      console.error(error);
    }
    setIsEditing(false);
  };

  const handleRowClick = (row) => { 
    setSelectedFilas(row); 
  }; 
  const handleRowDoubleClick = (row) => { 
    if (activeSection === 'Tareas de Mantenimiento') {
      setActiveButton('NoEditTM');
      setShowModal(true);
    }else if (activeSection === 'Ordenes de Mantenimiento') {
      setActiveButton('NoEditOM');
      setShowModal(true);
    }else if (activeSection === 'Historial de mantenimiento') {
      setShowModal(true);
    }else{
      console.log('Row double-clicked:', row); 
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    dispatch(selectSubMenu('machineDetails'));
    dispatch(setData('Maquinas'));
  }

  return (
    <div>
      <BarraContainer 
        buttonList={buttonList} 
        handleButtonClick={handleButtonClick}
        navigationHistory={navigationHistory}
      />
      <div className="machine-details" onMouseEnter={() => handleSectionClick('Detalles de la Máquina')}>
        <div className="machine-details__image">
          <img src={imageUrl} alt="Machine" />
        </div>
        <div className="machine-details__info">
          <h2>Detalles de la Máquina</h2>
          {isEditing ? (
            <>
              <p><strong>Fecha Instalación: </strong>
                <input
                  type="text"
                  value={editValues.Inst_Date_Machine}
                  onChange={(e) => handleInputChange('Inst_Date_Machine', e.target.value)}
                />
              </p>
              <p><strong>Código Interno: </strong>
                <input
                  type="text"
                  value={editValues.Internall_Code_Machine}
                  onChange={(e) => handleInputChange('Internall_Code_Machine', e.target.value)}
                />
              </p>
              <p><strong>Ubicación: </strong>
                <input
                  type="text"
                  value={editValues.Location_Machine}
                  onChange={(e) => handleInputChange('Location_Machine', e.target.value)}
                />
              </p>
              <p><strong>Nombre: </strong>
                <input
                  type="text"
                  value={editValues.Name_Machine}
                  onChange={(e) => handleInputChange('Name_Machine', e.target.value)}
                />
              </p>
              <p><strong>Observación: </strong>
                <input
                  type="text"
                  value={editValues.Observation_Machine}
                  onChange={(e) => handleInputChange('Observation_Machine', e.target.value)}
                />
              </p>
              <p><strong>Prioridad: </strong>
                <input
                  type="text"
                  value={editValues.Priority_Machine}
                  onChange={(e) => handleInputChange('Priority_Machine', e.target.value)}
                />
              </p>
              <p><strong>Referencia: </strong>
                <input
                  type="text"
                  value={editValues.Ref_Machine}
                  onChange={(e) => handleInputChange('Ref_Machine', e.target.value)}
                />
              </p>
              <p><strong>Estado: </strong>
                <select
                  name="state"
                  value={editValues.State_Machine}
                  onChange={(e) => handleInputChange('State_Machine', e.target.value)}
                  required
                >
                  <option value="">Selecciona un estado</option>
                  <option value="En operación">En operación</option>
                  <option value="En mantenimiento">En mantenimiento</option>
                  <option value="Fuera de servicio">Fuera de servicio</option>
                  <option value="En espera">En espera</option>
                  <option value="En instalación">En instalación</option>
                  <option value="Desactivada">Desactivada</option>
                  <option value="En calibración">En calibración</option>
                  <option value="En prueba">En prueba</option>
                  <option value="Reservada">Reservada</option>
                  <option value="En diagnóstico">En diagnóstico</option>
                </select>
              </p>
              <button onClick={handleSave}>Guardar</button>
            </>
          ) : (
            <>
              <p><strong>Fecha Instalación: </strong> {machine.Inst_Date_Machine}</p>
              <p><strong>Código Interno: </strong> {machine.Internall_Code_Machine}</p>
              <p><strong>Ubicación: </strong> {machine.Location_Machine}</p>
              <p><strong>Nombre: </strong> {machine.Name_Machine}</p>
              <p><strong>Observación: </strong> {machine.Observation_Machine}</p>
              <p><strong>Prioridad: </strong> {machine.Priority_Machine}</p>
              <p><strong>Referencia: </strong> {machine.Ref_Machine}</p>
              <p><strong>Estado: </strong> {machine.State_Machine}</p>
              <p><strong>Manual: </strong> 
                {machine.Path_Manual_Machine ? (
                  <a href={`${API_URL}${machine.Path_Manual_Machine}`} target="_blank" rel="noopener noreferrer">Manual</a>
                ) : (
                  "No Hay Documento"
                )}
              </p>
            </>
          )}
        </div>
      </div>
      <Modal show={showModal} handleClose={handleCloseModal}> 
        {activeSection === 'Detalles de la Máquina' && activeButton === 'import' ?(
          <UploadMachines handleCloseModal={handleCloseModal} /> 
        ):activeSection === 'Tareas de Mantenimiento' && activeButton === 'add' ?(
          <InsertTask navigationHistory={handleCloseModal} machine={machine} taskType = {taskType}/> 
        ):activeSection === 'Tareas de Mantenimiento' && activeButton === 'edit' ?(
          <InsertTask navigationHistory={handleCloseModal} machine={machine} taskType={taskType} isEdit={true} task={selectedFilas} /> 
        ):activeSection === 'Tareas de Mantenimiento' && activeButton === 'NoEditTM' ?(
          <InsertTask navigationHistory={handleCloseModal} machine={machine} taskType={taskType} isEdit={false} task={selectedFilas} /> 
        ):activeSection === 'Ordenes de Mantenimiento' && activeButton === 'edit' ?(
          <OrderManagement navigationHistory={handleCloseModal} isEdit={true} order={selectedFilas}/>
        ):activeSection === 'Ordenes de Mantenimiento' && activeButton === 'NoEditOM' ?(
          <OrderManagement navigationHistory={handleCloseModal} isEdit={false} order={selectedFilas}/>
        ):activeSection === 'Ordenes de Mantenimiento' && activeButton === 'add' ?(
          <InsertCorrectivo navigationHistory={handleCloseModal} machine = {machine} data={data1}/>
        ):activeSection === 'Historial de mantenimiento'?(
          <HistoryDetail history={historial} filterParam = 'Id_Order' filterValue = {selectedFilas && selectedFilas[0].Id_Machine ? selectedFilas[0].Id_Order : '' } handleClose = {handleCloseModal}
                                      />
        ): (
          <h1>NO SE HA PROGRAMADO ESTA FUNCION REPORTALO </h1>
        )
        }
      </Modal>
      <div onMouseEnter={() => handleSectionClick('Tareas de Mantenimiento')}>
        <TableContainer           
          title = {`Tareas de Mantenimiento de ${machine.Name_Machine}`}
          data={data1} 
          columns={columns1} 
          onRowClick={handleRowClick} 
          onRowDoubleClick={handleRowDoubleClick} 
          handleButtonClick = {handleButtonClick}
          loading = {loading}
          error={data1 && data1.length > 0 ? '' : 'No hay Tareas de Mantenimiento al consultar'}
          className ='task-table'
          buttonList = {buttonList.filter(button => button !== 'import')}
        />
      </div>
      <div onMouseEnter={() => handleSectionClick('Ordenes de Mantenimiento')}>
        <TableContainer           
          title = {`Ordenes de Mantenimiento de ${machine.Name_Machine}`}
          data={filteredOrders} 
          columns={tableColumnsOrders} 
          onRowClick={handleRowClick} 
          onRowDoubleClick={handleRowDoubleClick} 
          handleButtonClick = {handleButtonClick}
          loading = {loading}
          error={filteredOrders && filteredOrders.length > 0 ? '' : 'No hay Ordenes de Mantenimiento al consultar'}
          className ='task-table'
          buttonList = {buttonList.filter(button => button !== 'import').filter(button => button !== 'delete')}
          showPieChart = {true}
        />
      </div>
      <div onMouseEnter={() => handleSectionClick('Historial de mantenimiento')}>
        <TableContainer
            title="Historial de mantenimiento"
            data={filteredHistory}
            columns={tableColumnsHistory}
            onRowClick={handleRowClick}
            onRowDoubleClick={handleRowDoubleClick}
            handleButtonClick={handleButtonClick}
            loading={loading}
            error={filteredHistory && filteredHistory.length > 0 ? '' : 'No hay historial de mantenimiento al consultar'}
            className="task-table"
            buttonList= {buttonList.filter(button => button !== 'import').filter(button => button !== 'delete').filter(button => button !== 'edit').filter(button => button !== 'add')}
            showPieChart = {true}
        />
      </div>
    </div>
  );
};

MachineDetails.propTypes = {
  user: PropTypes.object.isRequired,
  machine: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
  })).isRequired,
  buttonList: PropTypes.arrayOf(PropTypes.string).isRequired,
  navigationHistory: PropTypes.func.isRequired,
};

export default MachineDetails;
